import dayjs from 'dayjs';

export const getSecondsRemaining = (endTime) => {
  const now = dayjs();
  const end = dayjs(endTime);
  return Math.max(0, end.diff(now, 'second'));
};

